// Named aliases for the orval-generated int enums. Codegen emits those enums with cryptic
// NUMBER_n members because the backend enums carry no string names in the OpenAPI schema
// (tracked as FU-9). Use these constants for readable value comparisons; keep the generated
// enum *types* (KeywordType / SearchType / SearchSortType) for type annotations.

export const KeywordTypes = {
    Alphanumeric: 1,
    Numeric: 2,
    Date: 3
} as const;

export const KeywordTypeLabels: Record<number, string> = {
    [KeywordTypes.Alphanumeric]: "Alphanumeric",
    [KeywordTypes.Numeric]: "Numeric",
    [KeywordTypes.Date]: "Date"
};

export const SearchTypes = {
    Equals: 0,
    Contains: 1,
    GreaterThan: 2,
    LessThan: 3,
    GreaterThanOrEqualTo: 4,
    LessThanOrEqualTo: 5
} as const;

export const SearchSortTypes = {
    OldestToNewest: 0,
    NewestToOldest: 1,
    MostRelevant: 2
} as const;

// per-instance AI opt-in status (mirrors the backend PFInstanceAiStatus enum: Off=0, Requested=1, Active=2)
export const AiStatuses = {
    Off: 0,
    Requested: 1,
    Active: 2
} as const;
